import React, { useState, useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Header from "../common/layout/header";
import Footer from "../common/layout/footer";
import { http } from "../helper";
import { BaseUrl } from "../common/config";
import DataTable from "react-data-table-component";
import Sidebar from "../common/sidebar";
import { dateformatwithuktime } from "../utilityfunctions";
import Popup from "../common/popup";
import DatePicker from "react-datepicker";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import * as XLSX from "sheetjs-style";
import moment from "moment";

const EmailLogs = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const filterRef = useRef(null);
  const { name } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [templist, setTempList] = useState([]);
  const [searchTextVal, setSearchTextVal] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [selectedEmailType, setSelectedEmailType] = useState("");
  const [selectedRow, setSelectedRow] = useState(null);
  //const [activeTab, setActiveTab] = useState("Email Sent");
  const initialTab = location.state?.activeTab || "Email Sent";
  const [activeTab, setActiveTab] = useState(initialTab);
  const [isMoreFilterVisible, setIsMoreFilterVisible] = useState(false);
  const [selectedDays, setSelectedDays] = useState("30");
  const [dateFrom, setDateFrom] = useState(null);
  const [dateTo, setDateTo] = useState(null);
  const [showCustomDate, setShowCustomDate] = useState(false);
  const [dateinvalid_error, setDateInvalidError] = useState(false);
  const [datefill_error, setDateFillError] = useState(false);
  const [activeScheduledTab, setActiveScheduledTab] = useState("all");
  const [showExportAlert, setShowExportAlert] = useState(false);
  const [isExporting, setIsExporting] = useState(false);
  const emailTypes = [
    { name: t("customer_intro_email_txt"), value: "customer_intro" },
    { name: t("logged_in_ordered_email_txt"), value: "logged_in_not_order" },
    {
      name: t("logged_in_ordered_email_cutoff_txt"),
      value: "logged_in_not_order_cutoff",
    },
    { name: t("abandoned_cart_email_txt"), value: "abandoned_cart" },
    { name: t("pinsa_promo_txt"), value: "promopinsa_offer" },
  ];
  const tabs = [
    t("email_sent_txt"),
    t("email_scheduled_txt"),
    t("email_not_sent_txt"),
    t("suppression_txt"),
  ];
  const tabToStatusMap = {
    [t("email_sent_txt")]: "sent",
    [t("email_scheduled_txt")]: "pending",
    [t("email_not_sent_txt")]: "bounced",
    [t("suppression_txt")]: "notsent",
  };

  const [scheduledTabs, setScheduledTabs] = useState([
    { name: t("all_txt"), value: "all", icon: "fa fa-check-circle", count: 0 },
    {
      name: t("today_schedule_txt"),
      value: "today",
      icon: "fa fa-calendar-o",
      count: 0,
    },
    {
      name: t("upcoming_schedule_txt"),
      value: "upcoming",
      icon: "fa fa-clock-o",
      count: 0,
    },
  ]);
  const formatDateOnly = (date, type = "display") => {
    if (!date) return "";
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    if (type === "payload") {
      return `${year}-${month}-${day}`;
    }
    return `${day}/${month}/${year}`;
  };
  const getFilterText = () => {
    if (selectedDays === "custom" && dateFrom && dateTo) {
      const fromDate = formatDateOnly(dateFrom);
      const toDate = formatDateOnly(dateTo);
      return `From ${fromDate} To ${toDate}`;
    } else {
      switch (selectedDays) {
        case "30":
          return t("last_30_days_txt");
        case "90":
          return t("last_90_days_txt");
        case "180":
          return t("last_180_days_txt");
        case "365":
          return t("last_1_year_txt");
        default:
          return "";
      }
    }
  };
  const [appliedFilterText, setAppliedFilterText] = useState(getFilterText());

  if (!sessionStorage.getItem("isLoggedIn")) window.location.href = "/";

  if (
    JSON.parse(sessionStorage.getItem("authData")) != "" &&
    !JSON.parse(
      sessionStorage.getItem("authData")
    ).adminRole.permissions.includes("manage_emailcampaign")
  ) {
    window.location.href = "/unauthorized";
  }
  useEffect(() => {
    if (location.state?.activeTab) {
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, []);
  // Fetch data from API
  const requestIdRef = useRef(0);
  const fetchData = async (payload) => {
    const id = ++requestIdRef.current;
    setIsLoading(true);
    try {
      let loginDetails = {};
      if (sessionStorage.getItem("authData")) {
        loginDetails = JSON.parse(sessionStorage.getItem("authData"));
      }
      let URL = BaseUrl + `admin/emailLogs`;
      const response = await http.post(URL, payload);
      let responseData = response.data.data;
      responseData = responseData.filter((item)=> item.emailType != 'vendor_verification');
      if (id === requestIdRef.current && response.data.success === true) {
        //const filteredData = responseData.filter((item) => !item.messageId && item.emailSentStatus === "sent");
      let filteredData = responseData.filter((item) => {
          // true if messageId exists and is non-empty
          const hasMessageId = Boolean(
            item?.messageId && String(item.messageId).trim()
          );

          // true if status is "sent" (case-insensitive)
          const isSent =
            String(item?.emailSentStatus ?? "")
              .trim()
              .toLowerCase() === "sent";

          // Exclude only when messageId is missing AND status is "sent"
          // Keep (return true) for everything else
          return hasMessageId || !isSent;
        });
      // Sort
      if (activeTab === t("email_scheduled_txt")) {
        filteredData = filteredData.slice().sort((a, b) => {
          return new Date(a.scheduledSendTime) - new Date(b.scheduledSendTime);
        });
      }
      setTempList(filteredData);
      setData(filteredData);
      }
    } catch (err) {
      console.log(err);
    } finally {
      if (id === requestIdRef.current) {
        setIsLoading(false);
      }
    }
  };
  //Initial data fetch
  useEffect(() => {
    const payload = {
      emaillogdays: 30,
      datefrom: "",
      dateto: "",
      emailSentStatus: tabToStatusMap[activeTab],
      emailType: selectedEmailType,
    };
    fetchData(payload);
  }, [name]);
  // Fetch whenever tab or email type changes
  useEffect(() => {
    //setSearchTextVal('');
    setActiveScheduledTab("all");
    const payload = {
      emaillogdays: selectedDays === "custom" ? "" : Number(selectedDays),
      datefrom:
        selectedDays === "custom" && dateFrom
          ? formatDateOnly(dateFrom, "payload")
          : "",
      dateto:
        selectedDays === "custom" && dateTo
          ? formatDateOnly(dateTo, "payload")
          : "",
      emailSentStatus: tabToStatusMap[activeTab],
      emailType: selectedEmailType,
    };
    fetchData(payload);
  }, [activeTab, selectedEmailType]);
  // Search filter
  useEffect(() => {
    filterData();
  }, [templist, searchTextVal, activeScheduledTab]);

  const handlefilterChange = (value) => {
    setSelectedEmailType(value);
  };

  const columns = [
    {
      name: t("account_code_txt"),
      selector: (row) => row?.accountCode,
      sortable: true,
    },
    {
      name: t("account_name_txt"),
      selector: (row) => row?.accountName,
      sortable: true,
    },
    {
      name: t("campaign_namee_txt"),
      selector: (row) => {
        if (row?.emailType === "customer_intro") {
          return t("customer_cam_name_txt");
        }
        if (row?.emailType === "promopinsa_offer") {
          return t("pinsa_promo_campaign_txt");
        }
        return row?.campaign?.emailCampaignName
          ? row?.campaign?.emailCampaignName
          : "-";
      },
      sortable: true,
    },
    {
      name: t("email_address_txt"),
      selector: (row) => row?.toEmail,
      sortable: true,
    },
    {
      name: t("email_type_txt"),
      selector: (row) =>
        emailTypes.find((opt) => opt.value === row.emailType)?.name ||
        row.emailType,
      sortable: true,
    },
    ...(activeTab !== "Suppression"
      ? [
          {
            name: t("email_status_txt"),
            cell: (row) => {
              let statusText = "";

              if (row.emailSentStatus === "sent") {
                statusText =
                  row.reminderCount && row.reminderCount > 0
                    ? row.reminderCount == 1
                      ? t("initial_email_sent_txt")
                      : t("reminder_sent_txt", { count: row.reminderCount - 1 })
                    : "Email Sent";

                return (
                  <a
                    href="#"
                    className="title-tooltip title-up button data-pop-btn"
                    onClick={(e) => {
                      e.preventDefault();
                      handleStatusClick(row);
                    }}
                  >
                    {statusText}
                  </a>
                );
              } else if (row.emailSentStatus === "bounced" && row.emailError) {
                statusText = t("email_not_sent_txt");
                return (
                  <a
                    href="#"
                    className="title-tooltip title-up"
                    data-title={row.emailError}
                    onClick={(e) => e.preventDefault()}
                  >
                    <b>{statusText}</b>
                  </a>
                );
              } else if (row.emailSentStatus === "pending") {
                statusText =
                  row.reminderCount && row.reminderCount > 0
                    ? row.reminderCount == 1
                      ? t("initial_email_scheduled_txt")
                      : t("reminder_scheduled_txt", {
                          count: row.reminderCount - 1,
                        })
                    : t("email_scheduled_txt");
              } else if (row.emailSentStatus === "notsent") {
                statusText = t("email_not_sent_txt");
              }
              // Return plain text for non-clickable rows
              return <>{statusText}</>;
            },
          },
        ]
      : []),
    ...(activeTab !== t("email_not_sent_txt")
      ? [
          {
            name: t("customer_activity_txt"),
            selector: (row) => {
              if (row?.customerStatus && row?.customerStatus !== "active") {
                let status = row.customerStatus;
                if (status === "deactive") {
                  status = t("deactivated_txt");
                } else if (status === "website_access_disabled") {
                  status = t("website_access_disabled_txt");
                } else if (status === "reminder_limit_reached") {
                  status = t("completed_txt");
                } else if (status === "restricted_account") {
                  status = t("restricted_account_status_txt");
                } else if (status === "cart_empty") {
                  status = t("cart_empty_txt");
                } else if (status === "no_empty_cart") {
                  status = t("no_empty_cart_txt");
                }
                return status.charAt(0).toUpperCase() + status.slice(1);
              }
              return "-";
            },
            sortable: true,
          },
        ]
      : []),
    // Show date column only if NOT in Suppression tab
    ...(activeTab !== "Suppression"
      ? [
          {
            name:
              activeTab === t("email_scheduled_txt")
                ? t("scheduled_date_txt")
                : t("sent_date_txt"),
            selector:
              activeTab === t("email_scheduled_txt")
                ? (row) =>
                    row?.scheduledSendTime
                      ? dateformatwithuktime(row?.scheduledSendTime)
                      : "-"
                : (row) =>
                    row?.emailSentDate
                      ? dateformatwithuktime(row?.emailSentDate)
                      : "-",
          },
        ]
      : []),
  ];

  const handleReset = () => {
    setSearchTextVal("");
  };
  const handleChange = async (value) => {
    setSearchTextVal(value);
  };
  const handleStatusClick = (row) => {
    setSelectedRow(row);
    setVisibleAlert(true);
  };
  const toggleMoreFilter = () => {
    setIsMoreFilterVisible((v) => !v);
  };
  const applyMoreFilter = async () => {
    setDateInvalidError(false);
    setDateFillError(false);
    if (selectedDays === "custom") {
      if (!dateFrom || !dateTo) {
        setDateFillError(true);
        return;
      }
      if (dateFrom > dateTo) {
        setDateInvalidError(true);
        return;
      }
    }
    const payload = {
      emaillogdays: selectedDays === "custom" ? "" : Number(selectedDays),
      datefrom:
        selectedDays === "custom" && dateFrom
          ? formatDateOnly(dateFrom, "payload")
          : "",
      dateto:
        selectedDays === "custom" && dateTo
          ? formatDateOnly(dateTo, "payload")
          : "",
      emailSentStatus: tabToStatusMap[activeTab],
      emailType: selectedEmailType,
    };
    fetchData(payload);
    setAppliedFilterText(getFilterText());
    setIsMoreFilterVisible(false);
  };
  const clearMoreFilter = () => {
    setSelectedDays("30");
    setDateFrom(null);
    setDateTo(null);
    setDateInvalidError(false);
    setDateFillError(false);
    setShowCustomDate(false);
    const payload = {
      emaillogdays: 30,
      datefrom: "",
      dateto: "",
      emailSentStatus: tabToStatusMap[activeTab],
      emailType: selectedEmailType,
    };
    fetchData(payload);
    setAppliedFilterText(getFilterText());
    setIsMoreFilterVisible(false);
  };
  useEffect(() => {
    if (!visibleAlert) return; // popup is closed → do nothing

    const container = document.querySelector(".emailLog-content");
    if (!container) return;

    const handler = (e) => {
      const anchor = e.target.closest("a");
      if (anchor && anchor.href) {
        e.preventDefault();
        window.open(anchor.href, "_blank", "noopener,noreferrer");
      }
    };

    container.addEventListener("click", handler);

    return () => container.removeEventListener("click", handler);
  }, [visibleAlert]);
  const replacePlaceholders = (content, row) => {
    if (!content || !row) return content;
    return content
      .replace(/{{accountName}}/g, row.accountName || "")
      .replace(/{{accountCode}}/g, row.accountCode || "")
      .replace(/{{toEmail}}/g, row.toEmail || "")
      .replace(
        /target=["']?_new["']?/gi,
        'target="_blank" rel="noopener noreferrer"'
      )
      .replace(
        /<a\s+(?![^>]*target=)/gi, // Detect <a ...> tags WITHOUT target
        '<a target="_blank" rel="noopener noreferrer" '
      );
  };
  useEffect(() => {
    function handleClickOutside(event) {
      if (filterRef.current && !filterRef.current.contains(event.target)) {
        setIsMoreFilterVisible(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const filterData = async () => {
    let currentFilterData = templist;
    //Search Filter
    if (searchTextVal.length > 0) {
      const lowercasedValue = searchTextVal.toLowerCase().trim();
      const searchKeys = ["accountName", "accountCode", "emailType", "toEmail"];
      currentFilterData = currentFilterData.filter((item) =>
        searchKeys.some((key) =>
          item[key]?.toString().toLowerCase().includes(lowercasedValue)
        )
      );
    }
    if (activeScheduledTab === "today" || activeScheduledTab === "upcoming") {
      const today = toDateOnly(new Date());
      if (activeScheduledTab === "today") {
        currentFilterData = currentFilterData.filter((item) => {
          let dt = new Date(item.scheduledSendTime);
          return isSameDate(toDateOnly(dt), today);
        });
      }

      if (activeScheduledTab === "upcoming") {
        currentFilterData = currentFilterData.filter((item) => {
          let dt = toDateOnly(new Date(item.scheduledSendTime));
          return dt > today;
        });
      }
    }
    if (activeScheduledTab === "today" || activeScheduledTab === "upcoming") {
      const today = toDateOnly(new Date());
      if (activeScheduledTab === "today") {
        currentFilterData = currentFilterData.filter((item) => {
          let dt = new Date(item.scheduledSendTime);
          return isSameDate(toDateOnly(dt), today);
        });
      }

      if (activeScheduledTab === "upcoming") {
        currentFilterData = currentFilterData.filter((item) => {
          let dt = toDateOnly(new Date(item.scheduledSendTime));
          return dt > today;
        });
      }
    }
    setData(currentFilterData);
  };

  const toDateOnly = (value) => {
    const d = new Date(value);
    if (isNaN(d)) return null; // invalid date guard
    return new Date(d.getFullYear(), d.getMonth(), d.getDate());
  };

  const isSameDate = (d1, d2) => {
    if (!d1 || !d2) return false;
    return (
      d1.getFullYear() === d2.getFullYear() &&
      d1.getMonth() === d2.getMonth() &&
      d1.getDate() === d2.getDate()
    );
  };

  const handleConfirmExportToExcel = () => {
    setShowExportAlert(true);
  };
  const confirmExport = () => {
    setIsExporting(true);
    setShowExportAlert(false);
    handleExportToExcel();
  };
  const handleExportToExcel = async () => {
    setIsExporting(true);
    const tabKeys = ["sent", "pending", "bounced", "notsent"];
    const tabNames = [
      t("email_sent_txt"),
      t("email_scheduled_txt"),
      t("email_not_sent_txt"),
      t("suppression_txt"),
    ];
    const payloadBase = {
      emaillogdays: selectedDays === "custom" ? "" : Number(selectedDays),
      datefrom:
        selectedDays === "custom" && dateFrom
          ? formatDateOnly(dateFrom, "payload")
          : "",
      dateto:
        selectedDays === "custom" && dateTo
          ? formatDateOnly(dateTo, "payload")
          : "",
      emailType: selectedEmailType,
    };
    try {
      // Fetch data for all tabs
      const allData = {};
      for (let i = 0; i < tabKeys.length; i++) {
        const payload = { ...payloadBase, emailSentStatus: tabKeys[i] };
        const response = await http.post(BaseUrl + "admin/emailLogs", payload);
        allData[tabKeys[i]] = response.data.success ? response.data.data : [];
      }
      const wb = XLSX.utils.book_new();
      tabKeys.forEach((key, index) => {
        const data = allData[key];
        const isScheduledTab = key === "pending";
        // Apply search filter first
        let filteredData = data;
        if (searchTextVal) {
          const lowercased = searchTextVal.toLowerCase().trim();
          filteredData = data.filter((item) =>
            ["accountName", "accountCode", "emailType", "toEmail"].some(
              (field) =>
                item[field]?.toString().toLowerCase().includes(lowercased)
            )
          );
        }
        // Get readable email type
        const emailTypeOption = selectedEmailType
          ? emailTypes.find((opt) => opt.value === selectedEmailType)
          : null;
        const emailTypeText = emailTypeOption
          ? ` - ${emailTypeOption.name} Customer(s)`
          : "";
        const searchFilterText = searchTextVal
          ? ` | Grouped by ${searchTextVal}`
          : "";
        const totalRecordsText = ` | Total Records: ${filteredData.length}`;
        const timeFilterText = appliedFilterText
          ? ` (${appliedFilterText})`
          : "";
        const firstRowText = `${tabNames[index]}${emailTypeText}${searchFilterText}${totalRecordsText}${timeFilterText}`;
        const headers = [
          t("account_code_txt"),
          t("account_name_txt"),
          t("campaign_namee_txt"),
          t("email_address_txt"),
          t("email_type_txt"),
          t("email_status_txt"),
          t("customer_activity_txt"),
          isScheduledTab ? t("scheduled_date_txt") : t("sent_date_txt"),
        ];
        const styledHeaders = headers.map((h) => ({
          v: h,
          s: { font: { bold: true }, alignment: { horizontal: "left" } },
        }));
        const getEmailStatusText = (row) => {
          if (row.emailSentStatus === "sent") {
            if (row.reminderCount && row.reminderCount > 0) {
              return row.reminderCount === 1
                ? t("initial_email_sent_txt")
                : t("reminder_sent_txt", { count: row.reminderCount - 1 });
            }
            return t("email_sent_txt");
          }
          if (row.emailSentStatus === "bounced") return t("email_not_sent_txt");
          if (row.emailSentStatus === "pending") {
            if (row.reminderCount && row.reminderCount > 0) {
              return row.reminderCount === 1
                ? t("initial_email_scheduled_txt")
                : t("reminder_scheduled_txt", { count: row.reminderCount - 1 });
            }
            return t("email_scheduled_txt");
          }
          if (row.emailSentStatus === "notsent") return t("email_not_sent_txt");
          return "-";
        };
        const getCustomerStatusText = (status) => {
          if (!status || status === "active") return "-";
          switch (status) {
            case "deactive":
              return t("deactivated_txt");
            case "website_access_disabled":
              return t("website_access_disabled_txt");
            case "reminder_limit_reached":
              return t("completed_txt");
            case "restricted_account":
              return t("restricted_account_status_txt");
            case "cart_empty":
              return t("cart_empty_txt");
            case "no_empty_cart":
              return t("no_empty_cart_txt");
            default:
              return status;
          }
        };
        const rows = filteredData.map((item) => [
          item.accountCode || "-",
          item.accountName || "-",
          item.emailType === "customer_intro"
            ? t("customer_cam_name_txt")
            : item.emailType === "promopinsa_offer"
            ? t("pinsa_promo_txt")
            : item.campaign?.emailCampaignName || "-",
          item.toEmail || "-",
          emailTypes.find((opt) => opt.value === item.emailType)?.name ||
            item.emailType,
          getEmailStatusText(item),
          getCustomerStatusText(item.customerStatus),
          isScheduledTab
            ? item.scheduledSendTime
              ? dateformatwithuktime(item.scheduledSendTime)
              : "-"
            : item.emailSentDate
            ? dateformatwithuktime(item.emailSentDate)
            : "-",
        ]);
        const noDataRow = [
          {
            v: "No records available",
            s: {
              font: {
                bold: true,
                sz: 14,
                italic: true,
                color: { rgb: "FF0000" },
              },
              alignment: { horizontal: "center" },
            },
          },
        ];
        const emptyRows = Array(5).fill([]);
        const worksheetData =
          filteredData.length > 0
            ? [
                [
                  {
                    v: firstRowText,
                    s: {
                      font: { bold: true },
                      alignment: { horizontal: "left" },
                    },
                  },
                ],
                styledHeaders,
                ...rows,
              ]
            : [
                [
                  {
                    v: firstRowText,
                    s: {
                      font: { bold: true },
                      alignment: { horizontal: "left" },
                    },
                  },
                ],
                [],
                ...emptyRows,
                noDataRow,
              ];
        const ws = XLSX.utils.aoa_to_sheet(worksheetData);
        ws["!merges"] = [
          // First row merge
          { s: { r: 0, c: 0 }, e: { r: 0, c: headers.length - 1 } },
        ];
        // If no records merge the No records available row too
        if (filteredData.length === 0) {
          const noDataRowIndex = 2 + emptyRows.length; // 2 for first row + header row + 5 empty rows
          ws["!merges"].push({
            s: { r: noDataRowIndex, c: 0 },
            e: { r: noDataRowIndex, c: headers.length - 1 },
          });
        }
        ws["!cols"] = headers.map((h, idx) => {
          let maxLength = h.length;
          if (filteredData.length > 0) {
            rows.forEach((r) => {
              maxLength = Math.max(maxLength, String(r[idx]).length);
            });
          }
          return { wch: maxLength + 5 };
        });
        XLSX.utils.book_append_sheet(wb, ws, tabNames[index]);
      });
      const exportDateTime = moment().format("DD-MM-YYYY");
      const fileName = `EmailLogs-${exportDateTime}.xlsx`;
      XLSX.writeFile(wb, fileName);
    } catch (error) {
      console.error("Export failed", error);
    } finally {
      setIsExporting(false);
    }
  };
  const customStyles = {
    rows: {
      style: {
        minHeight: "25px",
      },
    },
    headCells: {
      style: {
        padding: "8px", // override the cell padding for head cells
      },
    },
    cells: {
      style: {
        padding: "8px", // override the cell padding for data cells
      },
    },
  };
  const paginationComponentOptions = {
    rowsPerPageText: "",
    rangeSeparatorText: "",
    selectAllRowsItem: true,
    selectAllRowsItemText: "",
    noRowsPerPage: "",
  };

  return (
    <section className="dashboard-block">
      <Sidebar />
      <div className="dash-left">
        <Header />
        <section className="cart-block">
          <div className="container">
            <div className="flex-title">
              <h1 className="checkout-title">{t("email_log_title_txt")}</h1>
              <div className="prod-import-btn odr-expo-btn">
                <a
                  data-title="Export Filtered Records"
                  className="export-btn button title-tooltip title-left"
                  onClick={handleConfirmExportToExcel}
                >
                  {t("export_btn_txt")}
                </a>
              </div>
            </div>
            <div className="right-table-outer-wrap">
              <div className="table-filter search-orders ">
                <div className="orders-drop-left">
                  <div className="table-search-reset">
                    <div className="table-search">
                      <input
                        type="text"
                        value={searchTextVal}
                        onChange={(e) => handleChange(e.target.value)}
                        className="form-control"
                        placeholder={t("emaillog_search_txt")}
                      />
                    </div>
                    <button
                      className="submitbtn button search-email-btn"
                      onClick={(e) => filterData(searchTextVal)}
                    >
                      <i className="fa fa-search"></i>
                    </button>
                    <button
                      className="resetbtn"
                      type="reset"
                      onClick={() => handleReset()}
                    >
                      {t("reset_txt")}
                    </button>
                  </div>
                </div>
                <div className="orders-dropdown email-select-drop">
                  <select
                    className="handle-srch"
                    value={selectedEmailType}
                    onChange={(e) => handlefilterChange(e.target.value)}
                  >
                    <option value="">{t("all_txt")}</option>
                    {emailTypes.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.name}
                      </option>
                    ))}
                  </select>

                  {/* MORE FILTER  */}
                  <div className="select-drop" ref={filterRef}>
                    <a
                      className={
                        isMoreFilterVisible
                          ? "filter-btn button active"
                          : "filter-btn button"
                      }
                      onClick={toggleMoreFilter}
                    >
                      {t("more_filters_txt")}
                      <span className="filter-icon">
                        <i className="fa fa-sliders" aria-hidden="true"></i>
                      </span>
                    </a>

                    <div
                      className={
                        isMoreFilterVisible ? "filter-bx show" : "filter-bx"
                      }
                    >
                      <div className="filter-date-range">
                        <div className="fltr-dt-wrap">
                          <label>{t("emailog_date_range_txt")}</label>
                          <select
                            value={selectedDays}
                            onChange={(e) => {
                              const val = e.target.value;
                              setSelectedDays(val);
                              if (val === "custom") {
                                setShowCustomDate(true);
                              } else {
                                setShowCustomDate(false);
                                setDateFrom(null);
                                setDateTo(null);
                              }
                            }}
                          >
                            <option value="30">{t("last_30_days_txt")}</option>
                            <option value="90">{t("last_90_days_txt")}</option>
                            <option value="180">
                              {t("last_180_days_txt")}
                            </option>
                            <option value="365">{t("last_1_year_txt")}</option>
                            <option value="custom">{t("custom_txt")}</option>
                          </select>
                        </div>
                      </div>

                      <div
                        className={
                          showCustomDate
                            ? "fltr-dt-range show"
                            : "fltr-dt-range"
                        }
                      >
                        <div className="fltr--date">
                          <span>{t("from_txt")}</span>
                          <DatePicker
                            selected={dateFrom}
                            placeholderText={t("from_date_txt")}
                            dateFormat="dd/MM/yyyy"
                            maxDate={new Date()}
                            onChange={(date) => setDateFrom(date)}
                          />
                          <span className="date-icon">
                            <i
                              className="fa fa-calendar"
                              aria-hidden="true"
                            ></i>
                          </span>
                        </div>
                        <div className="fltr--date">
                          <span>{t("to_txt")}</span>
                          <DatePicker
                            selected={dateTo}
                            placeholderText={t("to_date_txt")}
                            dateFormat="dd/MM/yyyy"
                            maxDate={new Date()}
                            onChange={(date) => setDateTo(date)}
                          />
                          <span className="date-icon">
                            <i
                              className="fa fa-calendar"
                              aria-hidden="true"
                            ></i>
                          </span>
                        </div>
                      </div>

                      {dateinvalid_error === true && (
                        <span className="color-red">
                          {t("invalid_start_end_date_txt")}
                        </span>
                      )}
                      {datefill_error === true && (
                        <span className="color-red">
                          {t("fill_from_to_date_txt")}
                        </span>
                      )}

                      <div className="filter-btns">
                        <button
                          type="button"
                          className="button clear-btn"
                          onClick={clearMoreFilter}
                        >
                          {t("clear_txt")}
                        </button>
                        <button
                          type="button"
                          className="button apply-btn"
                          onClick={applyMoreFilter}
                        >
                          {t("apply_txt")}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* tabs */}
              <div className="right-table-outer-wrap">
                <div className="flex-container">
                  <div className="header-tab-menu">
                    {tabs.map((tab) => (
                      <a
                        key={tab}
                        className={activeTab === tab ? "active" : ""}
                        onClick={() => setActiveTab(tab)}
                      >
                        {tab}
                      </a>
                    ))}
                  </div>
                </div>
                {activeTab === t("email_scheduled_txt") && (
                  <div className="flex-container">
                    <div className="header-tab-menu header-tab-subs">
                      <div className="subTab-filter-text">Filter by Time</div>
                      <div className="subtab-menu">
                        {scheduledTabs.map((tab) => (
                          <a
                            key={tab.name}
                            className={
                              activeScheduledTab === tab.value ? "active" : ""
                            }
                            onClick={() => setActiveScheduledTab(tab.value)}
                          >
                            <i className={tab.icon}></i>
                            {tab.name}
                            <span className="filter-count">{tab.count}</span>
                          </a>
                        ))}
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {!isLoading && data.length > 0 && (
                <div className="admin-order account-total-records">
                  <br />
                  {t("total_record_txt")}
                  {data.length} ({appliedFilterText})
                </div>
              )}

              <div
                className={`table_overflow email-logs-table ${
                  activeTab === "Suppression"
                    ? "table_overflow suppression-table"
                    : ""
                }`}
              >
                <DataTable
                  columns={columns}
                  noDataComponent={
                    <div className="no-records-found">
                      {searchTextVal !== ""
                        ? t("no_records_search_txt", {
                            recordType: "Email Logs",
                          })
                        : t("no_record_txt")}
                    </div>
                  }
                  data={data}
                  customStyles={customStyles}
                  pagination
                  paginationPerPage={25}
                  progressPending={isLoading}
                  paginationRowsPerPageOptions={[25, 50, 75, 100]}
                  paginationComponentOptions={paginationComponentOptions}
                />
              </div>

              {/* {visibleAlert && (
                <div className="custom-alert-pop paylater-popup">
                  <div className="custom-alert-container">
                    <div className="custom-alert-wrap">
                      <div className="custom-alert-header">
                        <h4>Alert</h4>
                      </div>
                      <div className="custom-alert-body">
                        <p>Are you sure you want to delete?</p>

                        <div className="alert-buttons">
                          <a
                            onClick={() => deleteDepotValue()}
                            className="popup-alert-btn button"
                          >
                            OK
                          </a>
                          <a
                            onClick={() => alertPopupclose()}
                            className="popup-alert-btn button"
                          >
                            Cancel
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )} */}
              {visibleAlert && selectedRow && (
                <Popup
                  extClass="order-pop emaillog-details-pop"
                  closebtn={
                    <div className="pop-header-top order-top">
                      <div className="head">
                        <h4>
                          {t("email_detail_title", {
                            accountCode: selectedRow.accountCode,
                          })}
                        </h4>
                      </div>
                      <span
                        onClick={() => setVisibleAlert(false)}
                        className="close"
                      ></span>
                    </div>
                  }
                  bodyMoreTxt={
                    <div className="custom-alert-body text-left">
                      <div className="emailLog-hdr">
                        <p>
                          <strong>{t("from_txt")}:</strong>{" "}
                          {t("tugo_orders_txt")}
                        </p>
                        <p>
                          <strong>{t("to_txt")}:</strong> {selectedRow.toEmail}
                        </p>
                        <p>
                          <strong>{t("subject_txt")}:</strong>{" "}
                          {selectedRow.reminderCount === 0 || selectedRow.reminderCount === 1 
                            ? selectedRow.emailSubject
                            : selectedRow.reminderEmailSubject}
                        </p>
                      </div>
                      {/* <div className="modal-table"> */}
                      {/* <h5>Email Content</h5> */}

                      {/* <div className="table_overflow email-preview"> */}
                      {/* <div
                                                    className="email-body"
                                                    dangerouslySetInnerHTML={{ __html: selectedRow.emailContent }}
                                                /> */}
                      {
                        // const emailcontent= selectedRow.remindercount==1 ? selectedRow.emailContent : selectedRow.reminderEmailContent
                        selectedRow.emailContent ? (
                          <div
                            className="emailLog-content"
                            dangerouslySetInnerHTML={{
                              __html: replacePlaceholders(
                                new Date(selectedRow.emailSentDate) <
                                  new Date("2026-01-30")
                                  ? selectedRow.emailContent
                                  : selectedRow.reminderCount === 1
                                  ? selectedRow.emailContent
                                  : selectedRow.reminderEmailContent,
                                selectedRow
                              ),
                            }}
                          />
                        ) : (
                          <div className="emailLog-content">
                            <p
                              style={{
                                color: "gray",
                                fontStyle: "italic",
                                textAlign: "center",
                              }}
                            >
                              {" "}
                              {t("no_preview_txt")}{" "}
                            </p>
                          </div>
                        )
                      }
                      {/* </div> */}

                      {/* </div> */}
                    </div>
                  }
                />
              )}
              {isExporting && (
                <div className="loading-full-bg">
                  <div className="loading-buffer"></div>
                </div>
              )}
              {showExportAlert && (
                <div className="custom-alert-pop paylater-popup">
                  <div className="custom-alert-container">
                    <div className="custom-alert-wrap">
                      <div className="custom-alert-header">
                        <h4>{t("alert_txt")}</h4>
                      </div>
                      <div className="custom-alert-body">
                        <p>{t("export_confirm_txt")}</p>
                        <div className="alert-buttons">
                          <a
                            onClick={confirmExport}
                            className="popup-alert-btn button"
                          >
                            {t("ok_txt")}
                          </a>
                          <a
                            onClick={() => setShowExportAlert(false)}
                            className="popup-alert-btn button"
                          >
                            {t("cancel_txt")}
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </section>
  );
};
export default EmailLogs;
